import "./App.css";
// import HomePage from "./components/HomePage";
import Loading from "./components/Loading";
// import Navbar from "./components/Navbar";
// import ThemeToggle from "./components/ThemeToggle";
function App() {
  return (
    <div>
      <Loading />
    </div>
  );
}

export default App;
